import { ArticleTeaserCardRecommended } from "components/page-components/Teaser-Cards"
import React from "react"

export const RelatedArticlesHorizontal = ({ related_articles, ressort }) => {
  return (
    <div data-nosnippet>
      <p className="has-text-weight-bold mx-3 mb-4">
        {ressort === "umweltbau" ? "Weiterlesen:" : "Mehr zum Thema:"}
      </p>
      <div
        className="columns is-mobile no-scrollbar"
        style={{ overflow: "auto" }}
      >
        {related_articles?.map((article, index) => (
          <div
            className="column is-4-desktop is-11-mobile is-5-tablet"
            key={`related-article-${index}`}
          >
            <ArticleTeaserCardRecommended
              {...{
                article,
                defaultImage: null,
                ressort: article.ressort,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
